var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component"},[_c('div',{staticClass:"enaqPiediagramm"},[_c('apexchart',{attrs:{"width":"70%","type":"pie","options":_vm.graphOptions,"series":_vm.graphData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }